"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapAsyncDispatchToProps = mapAsyncDispatchToProps;
exports.asyncDispatch = void 0;

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _curry = _interopRequireDefault(require("lodash/curry"));

var _reactRedux = require("react-redux");

var asyncDispatch = (0, _curry["default"])(function (dispatch, actionFn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {
      return dispatch(actionFn.apply(void 0, [{
        resolve: resolve,
        reject: reject
      }].concat(args)));
    });
  };
});
/**
 * High order component to create redux action dispatchers that return promises.
 * This works by injecting `resolve` and `reject` callbacks into the first argument
 * of the action creator, which are left to be resolved by whichever async middleware
 * you happen to use.
 * Use just like `connect`'s `mapDispatchToProps`:
 * ```js
 * mapAsyncDispatchToProps({
 *   asyncAction: ({resolve, reject}) => ({type: 'ASYNC_ACTION', resolve, reject}})
 * })(MyComponent)
 * ```
 */

exports.asyncDispatch = asyncDispatch;

function mapAsyncDispatchToProps(actions) {
  return (0, _reactRedux.connect)(null, function (dispatch, props) {
    return typeof actions === 'function' ? actions(asyncDispatch(dispatch), props) : (0, _mapValues["default"])(actions, asyncDispatch(dispatch));
  });
}